import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import TeamExcellenceExpertisePersonality from "pages/team-excellence-expertise-personality";
import AboutMissionValues from "pages/about-mission-values";
import ContactEngagementHub from "pages/contact-engagement-hub";
import HomepageDigitalInnovationShowcase from "pages/homepage-digital-innovation-showcase";
import AiAssistantInterfaceIntelligentSupport from "pages/ai-assistant-interface-intelligent-support";
import TechnologyShowcaseInteractiveCapabilities from "pages/technology-showcase-interactive-capabilities";
import AdminPage from "pages/admin";
import ServicesListPage from "pages/services/ServicesListPage";
import ServiceDetailPage from "pages/services";
import IndustryDetailPage from "pages/industries";
import GlobalCollaboration from "pages/global-collaboration";
import LocationDetailPage from "pages/locations/LocationDetailPage";
import LocationsHubPage from "pages/locations/LocationsHubPage";
import BlogListPage from "pages/blog/BlogListPage";
import BlogPostPage from "pages/blog/BlogPostPage";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your routes here */}
          <Route path="/" element={<HomepageDigitalInnovationShowcase />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/blog" element={<AdminPage tab="blog" />} />
          <Route path="/admin/blog/new" element={<AdminPage tab="blog-new" />} />
          <Route path="/admin/blog/edit/:id" element={<AdminPage tab="blog-edit" />} />
          <Route path="/admin/blog/categories" element={<AdminPage tab="blog-categories" />} />
          <Route path="/admin/blog/tags" element={<AdminPage tab="blog-tags" />} />
          <Route path="/admin/blog/comments" element={<AdminPage tab="blog-comments" />} />
          <Route path="/admin/blog/settings" element={<AdminPage tab="blog-settings" />} />
          <Route path="/team-excellence-expertise-personality" element={<TeamExcellenceExpertisePersonality />} />
          <Route path="/about-mission-values" element={<AboutMissionValues />} />
          <Route path="/contact-engagement-hub" element={<ContactEngagementHub />} />
          <Route path="/homepage-digital-innovation-showcase" element={<Navigate to="/" replace />} />
          <Route path="/ai-assistant-interface-intelligent-support" element={<AiAssistantInterfaceIntelligentSupport />} />
          <Route path="/technology-showcase-interactive-capabilities" element={<TechnologyShowcaseInteractiveCapabilities />} />
          <Route path="/services" element={<ServicesListPage />} />
          <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/industries/:industryId" element={<IndustryDetailPage />} />
          <Route path="/global-collaboration" element={<GlobalCollaboration />} />
          <Route path="/locations" element={<LocationsHubPage />} />
          <Route path="/locations/:locationId" element={<LocationDetailPage />} />
          <Route path="/software-development-company-:locationId" element={<LocationDetailPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/blog/category/:category" element={<BlogListPage filterType="category" />} />
          <Route path="/blog/tag/:tag" element={<BlogListPage filterType="tag" />} />
          <Route path="/blog/search" element={<BlogListPage filterType="search" />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;